// IE Needs element.closest polyfill - see polyfills
// https://gomakethings.com/a-native-vanilla-javascript-way-to-get-the-closest-matching-parent-element/


class RadioSelection {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		// scoped to parent form or other form if specified
		this.form = this.options.formSelector
			? this.element.querySelector(this.options.formSelector)
			: this.element.closest('form');
		
		this.inputs = this.form.elements[this.options.name];
		this.button = this.form.querySelector('#' + this.options.name);

		if (!this.form || !this.options.name || !this.inputs) {
			return false;
		}

		this.init();
		this.watch();
	}

	init(){
		this.updateValue();
	}

	watch(){
		[...this.inputs].forEach((input)=>{
			input.addEventListener('change', this.updateValue.bind(this));
			input.addEventListener('blur', this.closeGroup.bind(this, event));
		});
	}

	closeGroup(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			this.button.trigger('closeAll');
		}
	}

	updateValue(){
		const value = this.inputs.value;
		const checkedInput = this.form.querySelector(`[value="${value}"]`);
		const label = this.form.querySelector(`label[for="${checkedInput.id}"]`);

		if (!label){
			console.warn('Label missing for radio input', checkedInput);
		}
		this.element.textContent = label.textContent;
	}

}

RadioSelection.DEFAULTS = {};

export default RadioSelection;



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__radio-selection/radio-selection.js